import { useState } from 'react'
import { Address } from '../../../../swagger'

export interface BillingAddressInformation {
  fullName: string
  address: Address
}

export interface UseBillingAddressFormReturn {
  billingAddressInformation: BillingAddressInformation
  setBillingAddressInformation: (info: BillingAddressInformation) => void
  requiredBillingInformationPresent: boolean
}

export const emptyAddressInformation = {
  locationName: '',
  streetAddress1: '',
  streetAddress2: '',
  city: '',
  state: '',
  zip: '',
  countryCode: 'US',
}

export const useBillingAddressForm = (): UseBillingAddressFormReturn => {
  const [billingAddressInformation, setBillingAddressInformation] =
    useState<BillingAddressInformation>({
      fullName: '',
      address: emptyAddressInformation,
    })

  const requiredBillingInformationPresent =
    !!billingAddressInformation.fullName &&
    !!billingAddressInformation.address.streetAddress1 &&
    !!billingAddressInformation.address.city &&
    !!billingAddressInformation.address.state &&
    !!billingAddressInformation.address.zip &&
    !!billingAddressInformation.address.countryCode

  return {
    billingAddressInformation,
    setBillingAddressInformation,
    requiredBillingInformationPresent,
  }
}
